<template>
    <div class="layout-container">
        <!-- Header Mejorado -->
        <header class="main-header" ref="mainHeader">
            <div class="header-top">
                <div class="container header-container">
                    <div class="header-brand">
                        <router-link to="/" class="brand-link">
                            <img
                                src="../src/img/logo_v2.jpg"
                                class="brand-logo"
                                :alt="siteData.title"
                            />
                            <div class="brand-text">
                                <h1 class="brand-title">CAPWASHMX</h1>
                                <p class="brand-tagline">
                                    <i>...Se lava ajeno!</i>
                                </p>
                            </div>
                        </router-link>
                    </div>
                    
                    <div class="header-actions">
                        <router-link
                            to="/agendar_cita"
                            class="cart-button"
                        >
                            <i class="fa fa-shopping-cart"></i>
                            <b class="">{{ count }}</b>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- Navigation Mejorada -->
            <nav class="main-nav">
                <div class="container nav-container">
                    <div class="nav-links" :class="{ 'mobile-open': mobileNavOpen }">
                        <router-link to="/" class="nav-link" exact-active-class="nav-active" @click="handleNavClick">
                            <i class="fa fa-home"></i>
                            Inicio
                        </router-link>
                        <router-link to="/servicios" class="nav-link" active-class="nav-active" @click="handleNavClick">
                            <i class="fa fa-wrench"></i>
                            Servicios
                        </router-link>
                        <router-link to="/puntos_de_recoleccion" class="nav-link" active-class="nav-active" @click="handleNavClick">
                            <i class="fa fa-map-pin"></i>

                            Puntos de Recolección
                        </router-link>
                        <router-link to="/galeria" class="nav-link" active-class="nav-active" @click="handleNavClick">
                            <i class="fa fa-camera"></i>
                            Galeria
                        </router-link>
                        <router-link to="/videos" class="nav-link" active-class="nav-active" @click="handleNavClick">
                            <i class="fa fa-play-circle"></i>
                            Videos
                        </router-link>
                    </div>

                    <button class="nav-toggle" @click="toggleMobileNav">
                        <span class="nav-toggle-bar" :class="{ 'open': mobileNavOpen }"></span>
                        <span class="nav-toggle-bar" :class="{ 'open': mobileNavOpen }"></span>
                        <span class="nav-toggle-bar" :class="{ 'open': mobileNavOpen }"></span>
                    </button>
                </div>
            </nav>
        </header>

        <!-- Main Content -->
        <main class="main-content bg-app">
            <div class="container">
                <router-view></router-view>
            </div>
        </main>

        <!-- WhatsApp Float -->
        <a
            href="https://wa.me/525533138568?text=Hola!%20Podemos%20agendar%20una%20cita?"
            target="_blank"
            rel="noopener noreferrer"
            class="whatsapp-float"
        >
            <i style="font-size:30px" class="fa fa-whatsapp"></i>
        </a>

        <!-- Footer -->
        <footer>
            <pie-de-pagina />
        </footer>

        <!-- Overlay para mobile nav -->
        <div 
            v-if="mobileNavOpen" 
            class="nav-overlay" 
            @click="closeMobileNav"
        ></div>
    </div>
</template>

<script>
import PieDePagina from "./components/PieDePagina.vue";
import { useStore } from "vuex";
import { computed, reactive, nextTick } from "vue";

export default {
    name: 'MainLayout',
    data() {
        return {
            mobileNavOpen: false
        };
    },
    setup() {
        const siteData = reactive({
            title: "CAP WASH MX",
            description: "Cap Wash México, Se lava ajeno!. Servicios de Lavado, Planchado y Restaurado de Gorras en México con CAPWASHMX.",
            keywords: "servicio,de,lavado,planchado,restaurado,de,gorras,maquina,de,vapor,capwashmx,se,lava,ajeno,cap,wash,mx",
        });

        const store = useStore();
        const count = computed(() => store.getters.cartItemCount);

        return { count, siteData };
    },
    components: { PieDePagina },
    methods: {
        toggleMobileNav() {
            this.mobileNavOpen = !this.mobileNavOpen;
            this.toggleBodyScroll();
            
            // Scroll al top cuando se abre el menú
            if (this.mobileNavOpen) {
                this.scrollToTop();
            }
        },
        
        closeMobileNav() {
            this.mobileNavOpen = false;
            this.toggleBodyScroll();
        },

        toggleBodyScroll() {
            if (this.mobileNavOpen) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },

        async handleNavClick() {
            this.closeMobileNav();
            await nextTick();
            this.scrollToTop();
        },

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

        handleResize() {
            // Cerrar menú móvil si se redimensiona a desktop
            if (window.innerWidth > 768 && this.mobileNavOpen) {
                this.closeMobileNav();
            }
        }
    },
    watch: {
        $route() {
            // Cerrar menú al cambiar de ruta
            if (this.mobileNavOpen) {
                this.closeMobileNav();
            }
            
            // Scroll al top después de un pequeño delay
            setTimeout(() => {
                this.scrollToTop();
            }, 100);
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.body.style.overflow = '';
    }
};
</script>

<style scoped>

.bg-app{
    background-color: #f5b56e !important;
}

@media (max-width: 767px) {
    .bg-app {
        background-color: transparent !important; /* Fondo transparente */
        /* O usa el color por defecto */
        /* background-color: inherit !important; */
    }
}

.layout-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.main-header {
    background: linear-gradient(135deg, #000 0%, #34495e 100%);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;
}

.header-top {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    padding: 15px 0;
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    gap: 15px;
}

.brand-link {
    display: flex;
    align-items: center;
    gap: 15px;
    text-decoration: none;
    transition: transform 0.3s ease;
    flex-shrink: 0;
}

.brand-logo {
    width: 80px;
    height: 80px;
    border-radius: 15px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
    border: 3px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.brand-text {
    color: white;
    text-align: left;
    flex: 1;
}

.brand-title {
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
    background: #f2f2f2;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(52, 152, 219, 0.3);
    line-height: 1.2;
}

.brand-tagline {
    margin: 0;
    font-size: 1rem;
    opacity: 0.9;
    font-style: italic;
    line-height: 1.3;
}

.cart-button {
    background: linear-gradient(135deg, #e74c3c, #c0392b);
    color: white;
    text-decoration: none;
    padding: 12px 20px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
    position: relative;
    flex-shrink: 0;
    white-space: nowrap;
}

.cart-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);
}

.main-nav {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

/* NAV LINKS - DESKTOP */
.nav-links {
    display: flex;
    gap: 5px;
    flex: 1;
}

.nav-link {
    color: #2c3e50;
    text-decoration: none;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
}

.nav-link::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: linear-gradient(135deg, #3498db, #2980b9);
    transition: all 0.3s ease;
    transform: translateX(-50%);
}

.nav-link:hover {
    color: #3498db;
    background: rgba(52, 152, 219, 0.1);
    text-decoration: none;
}

.nav-active {
    color: #3498db;
    background: rgba(52, 152, 219, 0.1);
}

.nav-active::before {
    width: 80%;
}

.nav-toggle {
    display: none;
    flex-direction: column;
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    gap: 4px;
    z-index: 1002;
}

.nav-toggle-bar {
    width: 25px;
    height: 3px;
    background: #2c3e50;
    transition: all 0.3s ease;
    border-radius: 2px;
    transform-origin: center;
}

.nav-toggle-bar.open:nth-child(1) {
    transform: rotate(45deg) translate(6px, 6px);
}

.nav-toggle-bar.open:nth-child(2) {
    opacity: 0;
}

.nav-toggle-bar.open:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
}

.main-content {
    flex: 1;
    padding: 30px 0;
    background: #f8f9fa;
    min-height: calc(100vh - 200px);
}

.whatsapp-float {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: #25d366;
    color: white;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
    transition: all 0.3s ease;
    z-index: 1000;
    animation: pulse 2s infinite;
}

.nav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: none;
}

@keyframes pulse {
    0% {
        box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
    }
    50% {
        box-shadow: 0 8px 25px rgba(37, 211, 102, 0.8);
    }
    100% {
        box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
    }
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* ================================ */
/* ESTILOS MÓVIL CORREGIDOS */
/* ================================ */

@media (max-width: 768px) {
    .header-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        gap: 10px;
    }
    
    .brand-link {
        flex-direction: row;
        text-align: left;
        flex: 1;
        min-width: 0;
    }
    
    .brand-title {
        font-size: 1.4rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .brand-tagline {
        font-size: 0.9rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .brand-logo {
        width: 60px;
        height: 60px;
    }
    
    .cart-button {
        padding: 10px 15px;
        font-size: 0.9rem;
    }
    
    /* Navigation Mobile - CORREGIDO */
    .nav-toggle {
        display: flex;
    }
    
    /* NAV LINKS - MOBILE (siempre oculto por defecto) */
    .nav-links {
        position: fixed;
        top: -100%;
        left: 0;
        width: 100%;
        background: white;
        flex-direction: column;
        padding: 80px 20px 20px 20px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        transition: top 0.4s ease;
        z-index: 1001;
        gap: 0;
        border-radius: 0 0 20px 20px;
        height: auto;
        max-height: calc(100vh - 80px);
        overflow-y: auto;
        display: none; /* Oculto por defecto */
    }
    
    /* Cuando mobileNavOpen es true, se muestra */
    .nav-links.mobile-open {
        top: 0;
        display: flex; /* Se muestra cuando tiene la clase mobile-open */
    }
    
    .nav-link {
        padding: 18px 20px;
        margin-bottom: 5px;
        justify-content: flex-start;
        width: 100%;
        border-radius: 10px;
        transition: all 0.3s ease;
        font-size: 1.1rem;
        border: 1px solid transparent;
    }
    
    .nav-link:hover {
        border-color: #3498db;
        transform: translateX(5px);
    }
    
    .nav-link i {
        font-size: 1.2rem;
        width: 25px;
    }
    
    .whatsapp-float {
        bottom: 20px;
        right: 20px;
        width: 55px;
        height: 55px;
    }
    
    /* Overlay solo se muestra cuando el menú está abierto */
    .nav-overlay {
        display: block;
        backdrop-filter: blur(2px);
    }
}

/* Efecto de aparición escalonada para los links */
.nav-links.mobile-open .nav-link:nth-child(1) {
    animation: fadeInUp 0.4s ease 0.1s both;
}

.nav-links.mobile-open .nav-link:nth-child(2) {
    animation: fadeInUp 0.4s ease 0.2s both;
}

.nav-links.mobile-open .nav-link:nth-child(3) {
    animation: fadeInUp 0.4s ease 0.3s both;
}

.nav-links.mobile-open .nav-link:nth-child(4) {
    animation: fadeInUp 0.4s ease 0.4s both;
}

.nav-links.mobile-open .nav-link:nth-child(5) {
    animation: fadeInUp 0.4s ease 0.5s both;
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 480px) {
    .brand-logo {
        width: 50px;
        height: 50px;
    }
    
    .brand-title {
        font-size: 1.2rem;
    }
    
    .brand-tagline {
        font-size: 0.8rem;
    }
    
    .cart-button {
        padding: 8px 12px;
    }
    
    .nav-links {
        padding: 80px 15px 15px 15px;
    }
    
    .nav-link {
        padding: 16px 18px;
        font-size: 1rem;
    }
    
    .main-content {
        padding: 20px 0;
    }
}
</style>